/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestDocumentUploadToken_requestDocumentUploadToken_Auth = { readonly __typename: 'Auth', readonly token: string };

export type RequestDocumentUploadToken_Mutation = { readonly __typename: 'Mutation', readonly requestDocumentUploadToken: RequestDocumentUploadToken_requestDocumentUploadToken_Auth | null };


export type RequestDocumentUploadTokenVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['ID']['input'];
}>;


export type RequestDocumentUploadToken = RequestDocumentUploadToken_Mutation;


export const RequestDocumentUploadTokenDocument = gql`
    mutation RequestDocumentUploadToken($salesforceCreditId: ID!) {
  requestDocumentUploadToken(creditApplicationId: $salesforceCreditId) {
    token
  }
}
    `;
export type RequestDocumentUploadTokenMutationFn = Apollo.MutationFunction<RequestDocumentUploadToken, RequestDocumentUploadTokenVariables>;

/**
 * __useRequestDocumentUploadToken__
 *
 * To run a mutation, you first call `useRequestDocumentUploadToken` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDocumentUploadToken` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDocumentUploadToken, { data, loading, error }] = useRequestDocumentUploadToken({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *   },
 * });
 */
export function useRequestDocumentUploadToken(baseOptions?: Apollo.MutationHookOptions<RequestDocumentUploadToken, RequestDocumentUploadTokenVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDocumentUploadToken, RequestDocumentUploadTokenVariables>(RequestDocumentUploadTokenDocument, options);
      }
export type RequestDocumentUploadTokenHookResult = ReturnType<typeof useRequestDocumentUploadToken>;
export type RequestDocumentUploadTokenMutationResult = Apollo.MutationResult<RequestDocumentUploadToken>;
export type RequestDocumentUploadTokenMutationOptions = Apollo.BaseMutationOptions<RequestDocumentUploadToken, RequestDocumentUploadTokenVariables>;